export const VENDOR_ROLE_NAME = 'vendor';
